export class ButtonDropdown {
    constructor() {
        if (this.buttonDropdown) {
            [...this.buttonDropdown].forEach(button => {
                this.addEventListeners(button)
            })
        }
    }

    addEventListeners(button) {
        button.addEventListener('click', () => {
            if (!button.classList.contains('active')) {
                this.open(button)
            } else {
                this.close(button)
            }
        })
        const socialLinks = button.querySelectorAll('a');
        [...socialLinks].forEach(link => {
            link.addEventListener('click', (e) => {
                e.stopPropagation()
            })
        })
    }

    get buttonDropdown() {
        return document.querySelectorAll('.js-button-dropdown') || false
    }

    open(button) {
        button.classList.add('active')
        const buttonDropDownContent = button.querySelector('.js-button-dropdown-content')
        setTimeout(() => {
            buttonDropDownContent.classList.add('open')
        }, 50)
    }

    close(button) {
        const buttonDropDownContent = button.querySelector('.js-button-dropdown-content')
        buttonDropDownContent.classList.remove('open')
        setTimeout(() => {
            button.classList.remove('active')
       }, 200)
    }
}
